export interface SizePreset {
  id: string;
  group: 'social' | 'ads' | 'web' | 'print' | 'video';
  name: string;
  width: number;
  height: number;
}

export const SIZE_PRESETS: SizePreset[] = [
  { id: 'ig-post', group: 'social', name: 'Instagram post', width: 1080, height: 1080 },
  { id: 'ig-portrait', group: 'social', name: 'Instagram portrait', width: 1080, height: 1350 },
  { id: 'ig-story', group: 'social', name: 'Stories / Reels', width: 1080, height: 1920 },
  { id: 'fb-post', group: 'social', name: 'Facebook post', width: 1200, height: 630 },
  { id: 'fb-cover', group: 'social', name: 'Facebook cover', width: 1640, height: 624 },
  { id: 'x-post', group: 'social', name: 'X / Twitter post', width: 1600, height: 900 },
  { id: 'linkedin-post', group: 'social', name: 'LinkedIn post', width: 1200, height: 627 },
  { id: 'telegram-post', group: 'social', name: 'Telegram post', width: 1280, height: 720 },
  { id: 'pinterest', group: 'social', name: 'Pinterest pin', width: 1000, height: 1500 },
  { id: 'og-image', group: 'web', name: 'Open Graph image', width: 1200, height: 630 },
  { id: 'web-hero', group: 'web', name: 'Website hero', width: 1920, height: 1080 },
  { id: 'email-header', group: 'web', name: 'Email header', width: 600, height: 200 },
  { id: 'yt-thumb', group: 'video', name: 'YouTube thumbnail', width: 1280, height: 720 },
  { id: 'ad-mrec', group: 'ads', name: 'Medium rectangle', width: 300, height: 250 },
  { id: 'ad-leaderboard', group: 'ads', name: 'Leaderboard', width: 728, height: 90 },
  { id: 'ad-skyscraper', group: 'ads', name: 'Wide skyscraper', width: 160, height: 600 },
  { id: 'ad-half-page', group: 'ads', name: 'Half page', width: 300, height: 600 },
  { id: 'ad-billboard', group: 'ads', name: 'Billboard', width: 970, height: 250 },
  { id: 'ad-mobile', group: 'ads', name: 'Mobile banner', width: 320, height: 50 },
  { id: 'ad-mobile-large', group: 'ads', name: 'Large mobile', width: 320, height: 100 },
  { id: 'a4-portrait', group: 'print', name: 'A4 portrait', width: 1240, height: 1754 },
  { id: 'a4-landscape', group: 'print', name: 'A4 landscape', width: 1754, height: 1240 },
  { id: 'business-card', group: 'print', name: 'Business card', width: 1050, height: 600 },
];

/** A canvas size saved by a workspace, shown next to the presets. */
export interface CustomSize {
  id: string;
  name: string;
  width: number;
  height: number;
}
